/* eslint-disable indent */
import React, { type FC } from "react";
import { type AxiosInstance } from "axios";
import { loadStripe } from "@stripe/stripe-js/pure";
import { renderToStaticMarkup } from "react-dom/server";
import { type StripeError } from "@stripe/stripe-js";

import { jsonDataFormatter, jsonErrorFormatter } from "@stadium/helpers/formatter";

export const loadStripePromise = (key: string) => loadStripe(key);

type StripeErrorSerializerOptions = {
  error: StripeError;
  MailTo: FC;
  showOriginalMessage?: boolean;
};

export const serializeStripeError = ({
  error,
  MailTo,
  showOriginalMessage = false,
}: StripeErrorSerializerOptions) => {
  const errorMessage = showOriginalMessage ? error.message : "Your payment could not be processed.";
  const displayErrorMessage = `${errorMessage} Please check your bank/credit card issuer and try again. If you still experience issues, please email ${renderToStaticMarkup(
    <MailTo />,
  )}.`;
  const displayErrorMessageHtml = (
    <>
      {errorMessage} Please check your bank/credit card issuer and try again. If you still
      experience issues, please email <MailTo />
    </>
  );

  return { ...error, displayErrorMessage, displayErrorMessageHtml };
};

export const createStripeSetupIntent = (client: AxiosInstance) =>
  client.post("/credit_cards/create_setup_intent");

export const addCardApi = (client: AxiosInstance, payload: { [param: string]: unknown }) =>
  client
    .post("/credit_cards", payload)
    .then(jsonDataFormatter)
    .catch((error) => {
      const err = jsonErrorFormatter(error.response, "card");
      throw err;
    });
